import React from "react";

// https://www.svgrepo.com/svg/522394/document-new
// https://www.svgrepo.com/author/Luka%20Marr/

/**
 * Renders a file SVG icon.
 */
export const FileIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path
        d="M13 3L16 6L19 9M13 3L5 3L5 21L19 21L19 9M13 3L13 9L19 9"
        stroke="currentColor"
        strokeLinejoin="round"
      />
    </svg>
  );
};
